import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { BorderedCard } from 'components/BorderedCard';
import { ProductVolumeInputField } from 'components/BusinessToolForm/components/VolumeInputField/ProductVolumeInputField';
import { PRODUCTION_PLANS_FIELDS_NUMBER } from 'components/BusinessToolForm/constants/fieldsNumber';
import { PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

import { concatWithDot } from 'helpers/string';

import { IProductionVolumeItemProps } from './types';

export const ProductionVolumeItem: React.FC<IProductionVolumeItemProps> = memo(({ name, disabled = false }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <BorderedCard>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <TextInputControl
            control={control}
            id={concatWithDot(name, PRODUCT_NAMES.NAME)}
            name={concatWithDot(name, PRODUCT_NAMES.NAME)}
            label={t('businessOperations.production.productVolume.product')}
            disabled={disabled}
            data-mirror-field={concatWithDot(name, `${PRODUCT_NAMES.NAME}.${PRODUCTION_PLANS_FIELDS_NUMBER}`)}
            maxLength={50}
          />
        </Grid>
        <Grid item xs={4}>
          <ProductVolumeInputField name={name} disabled={disabled} />
        </Grid>
        <Grid item xs={4}>
          <NumberInputControlled
            control={control}
            id={concatWithDot(name, PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE)}
            name={concatWithDot(name, PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE)}
            label={t('businessOperations.production.productVolume.annualGrowth')}
            disabled={disabled}
            adornmentType="percentage"
            data-mirror-field={concatWithDot(name, `${PRODUCT_NAMES.ANNUAL_SALES_GROWTH_RATE}.${PRODUCTION_PLANS_FIELDS_NUMBER}`)}
          />
        </Grid>
      </Grid>
    </BorderedCard>
  );
});
